import {
  faAddressBook,
  faHeadset,
  faHouseUser,
  faScrewdriver,
  faUserCog,
  faUserMd,
  faUserNurse,
  faUserTie,
  faPeopleGroup,
} from '@fortawesome/free-solid-svg-icons';

// Copyright (c) 2020 by Will Bamford (https://codepen.io/WebSeed/pen/pvgqEq)
function componentToHex(c) {
  var hex = c.toString(16);
  return hex.length === 1 ? '0' + hex : hex;
}

export function rgbToHex(r, g, b) {
  return '#' + componentToHex(r) + componentToHex(g) + componentToHex(b);
}

export function hexToRgb(hex) {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b;
  });

  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
}

export function rgbColourIsLight(r, g, b) {
  // Counting the perceptive luminance
  // human eye favors green color...
  var a = 1 - (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return a < 0.5;
}

export function hexColourIsLight(color) {
  const { r, g, b } = hexToRgb(colourNameToHex(color));

  // Counting the perceptive luminance
  // human eye favors green color...
  var a = 1 - (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return a < 0.5;
}

export function colourNameToHex(colour) {
  const colours = {
    aliceblue: '#f0f8ff',
    antiquewhite: '#faebd7',
    aqua: '#00ffff',
    aquamarine: '#7fffd4',
    azure: '#f0ffff',
    beige: '#f5f5dc',
    bisque: '#ffe4c4',
    black: '#000000',
    blanchedalmond: '#ffebcd',
    blue: '#0000ff',
    blueviolet: '#8a2be2',
    brown: '#a52a2a',
    burlywood: '#deb887',
    cadetblue: '#5f9ea0',
    chartreuse: '#7fff00',
    chocolate: '#d2691e',
    coral: '#ff7f50',
    cornflowerblue: '#6495ed',
    cornsilk: '#fff8dc',
    crimson: '#dc143c',
    cyan: '#00ffff',
    darkblue: '#00008b',
    darkcyan: '#008b8b',
    darkgoldenrod: '#b8860b',
    darkgray: '#a9a9a9',
    darkgreen: '#006400',
    darkkhaki: '#bdb76b',
    darkmagenta: '#8b008b',
    darkolivegreen: '#556b2f',
    darkorange: '#ff8c00',
    darkorchid: '#9932cc',
    darkred: '#8b0000',
    darksalmon: '#e9967a',
    darkseagreen: '#8fbc8f',
    darkslateblue: '#483d8b',
    darkslategray: '#2f4f4f',
    darkturquoise: '#00ced1',
    darkviolet: '#9400d3',
    deeppink: '#ff1493',
    deepskyblue: '#00bfff',
    dimgray: '#696969',
    dodgerblue: '#1e90ff',
    firebrick: '#b22222',
    floralwhite: '#fffaf0',
    forestgreen: '#228b22',
    fuchsia: '#ff00ff',
    gainsboro: '#dcdcdc',
    ghostwhite: '#f8f8ff',
    gold: '#ffd700',
    goldenrod: '#daa520',
    gray: '#808080',
    green: '#008000',
    greenyellow: '#adff2f',
    honeydew: '#f0fff0',
    hotpink: '#ff69b4',
    indianred: '#cd5c5c',
    indigo: '#4b0082',
    ivory: '#fffff0',
    khaki: '#f0e68c',
    lavender: '#e6e6fa',
    lavenderblush: '#fff0f5',
    lawngreen: '#7cfc00',
    lemonchiffon: '#fffacd',
    lightblue: '#add8e6',
    lightcoral: '#f08080',
    lightcyan: '#e0ffff',
    lightgoldenrodyellow: '#fafad2',
    lightgrey: '#d3d3d3',
    lightgreen: '#90ee90',
    lightpink: '#ffb6c1',
    lightsalmon: '#ffa07a',
    lightseagreen: '#20b2aa',
    lightskyblue: '#87cefa',
    lightslategray: '#778899',
    lightsteelblue: '#b0c4de',
    lightyellow: '#ffffe0',
    lime: '#00ff00',
    limegreen: '#32cd32',
    linen: '#faf0e6',
    magenta: '#ff00ff',
    maroon: '#800000',
    mediumaquamarine: '#66cdaa',
    mediumblue: '#0000cd',
    mediumorchid: '#ba55d3',
    mediumpurple: '#9370d8',
    mediumseagreen: '#3cb371',
    mediumslateblue: '#7b68ee',
    mediumspringgreen: '#00fa9a',
    mediumturquoise: '#48d1cc',
    mediumvioletred: '#c71585',
    midnightblue: '#191970',
    mintcream: '#f5fffa',
    mistyrose: '#ffe4e1',
    moccasin: '#ffe4b5',
    navajowhite: '#ffdead',
    navy: '#000080',
    oldlace: '#fdf5e6',
    olive: '#808000',
    olivedrab: '#6b8e23',
    orange: '#ffa500',
    orangered: '#ff4500',
    orchid: '#da70d6',
    palegoldenrod: '#eee8aa',
    palegreen: '#98fb98',
    paleturquoise: '#afeeee',
    palevioletred: '#d87093',
    papayawhip: '#ffefd5',
    peachpuff: '#ffdab9',
    peru: '#cd853f',
    pink: '#ffc0cb',
    plum: '#dda0dd',
    powderblue: '#b0e0e6',
    purple: '#800080',
    rebeccapurple: '#663399',
    red: '#ff0000',
    rosybrown: '#bc8f8f',
    royalblue: '#4169e1',
    saddlebrown: '#8b4513',
    salmon: '#fa8072',
    sandybrown: '#f4a460',
    seagreen: '#2e8b57',
    seashell: '#fff5ee',
    sienna: '#a0522d',
    silver: '#c0c0c0',
    skyblue: '#87ceeb',
    slateblue: '#6a5acd',
    slategray: '#708090',
    snow: '#fffafa',
    springgreen: '#00ff7f',
    steelblue: '#4682b4',
    tan: '#d2b48c',
    teal: '#008080',
    thistle: '#d8bfd8',
    tomato: '#ff6347',
    turquoise: '#40e0d0',
    violet: '#ee82ee',
    wheat: '#f5deb3',
    white: '#ffffff',
    whitesmoke: '#f5f5f5',
    yellow: '#ffff00',
    yellowgreen: '#9acd32',
  };

  if (typeof colours[colour.toLowerCase()] != 'undefined') return colours[colour.toLowerCase()];

  return colour;
}

/**
 * Extract the file name from a path, without the extension
 * @param {string} filePath
 */
export function extractFileName(filePath) {
  if(filePath == null)
    return filePath;
  const lastSlashPos = filePath.lastIndexOf('/');
  const dotPost = filePath.lastIndexOf('.');
  return filePath.slice(lastSlashPos + 1, dotPost);
}

export function extractFullFileName(filePath) {
  if(filePath == null)
    return filePath;
  const lastSlashPos = filePath.lastIndexOf('/');
  return filePath.slice(lastSlashPos + 1, filePath.length);
}

export function timestampToLocalDateString(timestamp, locale) {
  let date = new Date();
  date.setTime(timestamp * 1000);
  return date.toLocaleDateString(locale);
}

export function timestampToLocalTimeString(timestamp, locale) {
  let date = new Date();
  date.setTime(timestamp * 1000);
  return date.toLocaleTimeString(locale);
}

export function timestampToLocalString(timestamp, locale, dateStyle = 'medium', timeStyle = 'medium') {
  let date = new Date();
  date.setTime(timestamp * 1000);
  return date.toLocaleString(locale, { dateStyle: dateStyle, timeStyle: timeStyle });
}

export function timestampToLocalStringO(timestamp, locale, options) {
  let date = new Date();
  date.setTime(timestamp * 1000);
  return date.toLocaleString(locale, options);
}

export function timestampToDate(timestamp) {
  if (timestamp == null) return null;

  let date = new Date();
  date.setTime(timestamp * 1000);
  return date;
}

export function dateToTimestamp(date) {
  if (null_or_undefined(date)) return date;
  return Math.round(date.getTime() / 1000);
}

export function getAge(date) {
  var today = new Date();
  var birthDate = timestampToDate(date);
  if (birthDate === null) return NaN;
  var age = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}

export function encodeRFC5987ValueChars(str) {
  return (
    encodeURIComponent(str)
      // Notare che anche se per l'RFC3986 "!" è riservato, non lo è per
      // l' RFC5987, quindi non viene sostituito
      .replace(/['()]/g, escape) // i.e., %27 %28 %29
      .replace(/\*/g, '%2A')
      // Per l'RFC5987 questi caratteri non necessitano di essere codificati,
      // quindi possiamo consentire un po' più di leggibilità: |`^
      .replace(/%(?:7C|60|5E)/g, unescape)
  );
}

export function parseTimeDuration(timeString) {
  if (null_or_undefined(timeString)) return timeString;

  const timePortions = timeString.match(/^(?:(\d{1,32}):)*(?:(\d{1,2}):)(\d{1,2})$|^(\d{1,32})$/);
  let res = 0;

  if (timePortions === null) return null;

  if (timePortions[1] !== void 0) {
    res += parseInt(timePortions[1]) * 3600;
  }

  if (timePortions[2] !== void 0) {
    res += parseInt(timePortions[2]) * 60;
  }

  if (timePortions[3] !== void 0) {
    res += parseInt(timePortions[3]);
  }

  if (timePortions[4] !== void 0) {
    res = parseInt(timePortions[4]);
  }

  return res;
}

export function leapYear(year) {
  return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

export function getDaysInMonth(month, year) {
  if (null_or_undefined(month)) return 30;

  switch (month) {
    case 11:
    case 4:
    case 6:
    case 9:
      return 30;

    case 2:
      if (leapYear(year)) return 29;
      return 28;

    default:
      return 31;
  }
}

export function secondsToElapsedTimeStr(elapsedSeconds, translator, showType = 'short') {
  const time = elapsedSeconds >= 0 ? elapsedSeconds : 0;
  const days = Math.floor(time / (60 * 60 * 24));
  const hours = Math.floor((time % (60 * 60 * 24)) / (60 * 60));
  const minutes = Math.floor((time % (60 * 60)) / 60);
  const seconds = Math.floor(time % 60);
  let elapsedTimeString = '';

  let hasSeconds = false;
  if (!days || showType === 'full') {
    if (showType === 'full') {
      hasSeconds = true;
    } else {
      if (!(hours || minutes)) {
        hasSeconds = true;
      }
    }
  }

  if (days) {
    elapsedTimeString = elapsedTimeString + days + ' ' + translator('dayAbbrev') + ' ';
  }
  if (days || hours) {
    elapsedTimeString =
      elapsedTimeString +
      hours.toString().padStart(2, '0') +
      ' ' +
      translator('hourAbbrev') +
      (minutes || hasSeconds ? ' ' : '');
  }
  if (minutes) {
    elapsedTimeString =
      elapsedTimeString + minutes.toString().padStart(2, '0') + ' ' + translator('minAbbrev') + (hasSeconds ? ' ' : '');
  }
  if (hasSeconds) {
    elapsedTimeString = elapsedTimeString + seconds.toString().padStart(2, '0') + ' ' + translator('secAbbrev');
  }
  return elapsedTimeString;
}

export function not_null_or_undefined(variableToCheck) {
  return variableToCheck !== null && variableToCheck !== void 0;
}

export function null_or_undefined(variableToCheck) {
  return !not_null_or_undefined(variableToCheck);
}

export function convertFontAwesomeIconName(iconName) {
  switch (iconName) {
    case 'fa-screwdriver':
      return faScrewdriver;

    case 'fa-user-cog':
      return faUserCog;

    case 'fa-user-nurse':
      return faUserNurse;

    case 'fa-user-md':
      return faUserMd;

    case 'fa-user-tie':
      return faUserTie;

    case 'fa-house-user':
      return faHouseUser;

    case 'fa-address-book':
      return faAddressBook;

    case 'fa-headset':
      return faHeadset;

    case 'fa-people-group':
      return faPeopleGroup;

    case 'fa-moon':
      return faMoon;

    default:
      return null;
  }
}

export function convertToDMS(lat, lon, fractionalDigits) {
  if(fractionalDigits == null)
    fractionalDigits = 1;

  let latDirection = lat >= 0 ? "N" : "S";
  let lonDirection = lon >= 0 ? "E" : "W";

  let latDegrees = Math.floor(Math.abs(lat));
  let latMinutes = Math.floor((Math.abs(lat) - latDegrees) * 60);
  let latSeconds = ((Math.abs(lat) - latDegrees - latMinutes / 60) * 3600).toFixed(fractionalDigits);

  let lonDegrees = Math.floor(Math.abs(lon));
  let lonMinutes = Math.floor((Math.abs(lon) - lonDegrees) * 60);
  let lonSeconds = ((Math.abs(lon) - lonDegrees - lonMinutes / 60) * 3600).toFixed(fractionalDigits);

  return {
    latitude: {
      degrees: latDegrees,
      minutes: latMinutes,
      seconds: latSeconds,
      direction: latDirection
    },
    longitude: {
      degrees: lonDegrees,
      minutes: lonMinutes,
      seconds: lonSeconds,
      direction: lonDirection
    },
    fullString: `${latDegrees}°${latMinutes}'${latSeconds}"${latDirection} ${lonDegrees}°${lonMinutes}'${lonSeconds}"${lonDirection}`
  };
}
